import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../lib/utils';

const vAlertVariants = cva('flex gap-3 rounded-xl border p-4 text-sm', {
  variants: {
    variant: {
      info: 'border-info-200 bg-info-50 text-info-800',
      success: 'border-success-200 bg-success-50 text-success-800',
      warning: 'border-warning-200 bg-warning-50 text-warning-800',
      error: 'border-error-200 bg-error-50 text-error-800',
    },
  },
  defaultVariants: { variant: 'info' },
});

type VAlertProps = React.ComponentPropsWithoutRef<'div'> &
  VariantProps<typeof vAlertVariants> & {
    title?: string;
  };

export const VAlert = React.forwardRef<HTMLDivElement, VAlertProps>(
  function VAlert({ className, variant, title, children, ...props }, ref) {
    return (
      <div ref={ref} role="alert" className={cn(vAlertVariants({ variant, className }))} {...props}>
        <div className="flex flex-col gap-1">
          {title && <p className="font-semibold">{title}</p>}
          {children && <div>{children}</div>}
        </div>
      </div>
    );
  },
);
VAlert.displayName = 'VAlert';

export { vAlertVariants };
export type { VAlertProps };
